// extracted by mini-css-extract-plugin
export default {"scholasticTable":"vSRcVYqpbm7DUf3rFvlM"};